import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import Button from "../../../../shared/components/buttons/Button"
import { StyleVariants } from "../../../../shared/state/sharedTypes"
import { deleteCaseSharedAssetAction } from "../../state/caseSharedAssetsActions"

interface Props {
  userSharedAssetId: string
  caseId: string
  userId: string
}

const RemoveSharedAssetButton: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation(["case"])
  const [clicked, setClicked] = useState(false)
  const dispatch = useDispatch()

  const onClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    e.nativeEvent.stopImmediatePropagation()
    if (!clicked) {
      setClicked(true)
      dispatch(deleteCaseSharedAssetAction(
        props.caseId,
        props.userSharedAssetId,
        props.userId
      ))
    }
  }

  return (
    <Button action={onClick} isChunky={false} variant={StyleVariants.ORANGE} className="h-8">
      {t("case:deselectAsset")}
    </Button>
  )
}

export default RemoveSharedAssetButton
